import * as constants from "../constants";

const PageBuilderRoute = {
    path: "/pagebuilder",
    displayName: "Page Builder",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.TELENOR_FULL_AUTH,
        constants.WAOO_FULL_AUTH,
        constants.BACKSTAGE_DEMO_FULL_AUTH,
        constants.SLOVAK_TELEKOM_FULL_AUTH
    ]
};

const ModelComparisonRoute = {
    path: "/modelcomparison",
    displayName: "Comparison",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.TELENOR_FULL_AUTH,
        constants.WAOO_FULL_AUTH,
        constants.BACKSTAGE_DEMO_FULL_AUTH,
        constants.SLOVAK_TELEKOM_FULL_AUTH
    ]
};


const LaneBuilderRoute = {
    path: "/lanebuilder",
    displayName: "Lane Builder",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.TELENOR_FULL_AUTH,
        constants.WAOO_FULL_AUTH,
        constants.BACKSTAGE_DEMO_FULL_AUTH,
        constants.SLOVAK_TELEKOM_FULL_AUTH
    ]
};

const TesterRoute = {
    path: "/tester",
    displayName: "Tester",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH
    ],
    defaultForGroup: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH
    ]
};

// const PagesRoute = {
//     path: "/pages",
//     displayName: "Pages",
//     groups: [
//         constants.THE_FILTER_FULL_AUTH
//     ]
// };

const SlotsViewerRoute = {
    path: "/slots",
    displayName: "Slots Viewer",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.EPIX_FULL_AUTH,
        constants.TELENOR_FULL_AUTH,
        constants.WAOO_FULL_AUTH,
        constants.BACKSTAGE_DEMO_FULL_AUTH,
        constants.SLOVAK_TELEKOM_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH,
        constants.TASTEMADE_FULL_AUTH
    ]
};

const FallbackViewerRoute = {
    path: "/fallbackviewer",
    displayName: "Fallback Viewer",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ]
};

const SlotsEditorRoute = {
    path: "/slotseditor",
    displayName: "Slots Editor",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ]
};

const ExperimentsRoute = {
    path: "/experiments",
    displayName: "Experiments",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ]
};

const ModelConfigRoute = {
    path: "/modelconfig",
    displayName: "Configuration",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ]
};

const SearchRoute = {
    path: "/search",
    displayName: "Search",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.EPIX_FULL_AUTH,
        constants.TELENOR_FULL_AUTH,
        constants.WAOO_FULL_AUTH,
        constants.BACKSTAGE_DEMO_FULL_AUTH,
        constants.SLOVAK_TELEKOM_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH,
        constants.TASTEMADE_FULL_AUTH
    ],
    defaultForGroup: [
        constants.EPIX_FULL_AUTH
    ]
};

const MetadataRoute = {
    path: "/metadata",
    displayName: "Metadata",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.TELENOR_FULL_AUTH,
        constants.WAOO_FULL_AUTH,
        constants.BACKSTAGE_DEMO_FULL_AUTH,
        constants.SLOVAK_TELEKOM_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH,
        constants.TASTEMADE_FULL_AUTH
    ],
    hide: true
};

const EntitiesRoute = {
    path: "/entities",
    displayName: "Search",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const EntitiesReportRoute = {
    path: "/entitiesreport",
    displayName: "Report",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const EntitiesDetailRoute = {
    path: "/entitiesdetail",
    displayName: "EntitiesDetail",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.RTVE_FULL_AUTH // only rtve_ful_auth (not read_auth!)
    ],
    hide: true
};

const MultiTaggingRoute = {
    path: "/multitagging",
    displayName: "Multi-Tagging",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ]
};

const PromotionsRoute = {
    path: "/promotions",
    displayName: "Promotions",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.TELENOR_FULL_AUTH,
        constants.WAOO_FULL_AUTH,
        constants.BACKSTAGE_DEMO_FULL_AUTH,
        constants.SLOVAK_TELEKOM_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const BlockingRoute = {
    path: "/blocking",
    displayName: "Blocking",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.DEMO_FULL_AUTH,
        constants.TELENOR_FULL_AUTH,
        constants.WAOO_FULL_AUTH,
        constants.BACKSTAGE_DEMO_FULL_AUTH,
        constants.SLOVAK_TELEKOM_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

// Analytics sub-routes
const CustomerOverviewRoute = {
    path: "/analytics/internal/customer-overview",
    displayName: "Customer Overview",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const BusinessImpressionsRoute = {
    path: "/analytics/internal/business-impressions",
    displayName: "Business Impressions",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const AdImpressionsRoute = {
    path: "/analytics/internal/ad-impressions",
    displayName: "Ad Impressions",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const KpiDashboardRoute = {
    path: "/analytics/external/kpi-dashboard",
    displayName: "KPI Dashboard",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.REVRY_FULL_AUTH
    ],
    hide: true
};

const ContentDashboardRoute = {
    path: "/analytics/external/content-dashboard",
    displayName: "Content Dashboard",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.REVRY_FULL_AUTH
    ],
    hide: true
};

const GenreExplorerRoute = {
    path: "/analytics/external/content-genre-explorer",
    displayName: "Genre Explorer",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.REVRY_FULL_AUTH
    ],
    hide: true
};

const RecsDashboardRoute = {
    path: "/analytics/external/recs-dashboard",
    displayName: "Recommendations Dashboard",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const AnalyticsPlaygroundRoute = {
    path: "/analytics/external/playground",
    displayName: "Analytics Playground",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const DailyVideoEngagementRoute = {
    path: "/analytics/external/daily-video-engagement",
    displayName: "Daily Video Engagement",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const DailyEventTrafficRoute = {
    path: "/analytics/external/daily-event-traffic",
    displayName: "Daily Event Traffic",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const EventInfoRoute = {
    path: "/analytics/external/event-info",
    displayName: "Event Info",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.REVRY_FULL_AUTH
    ],
    hide: true
};

const WeeklyExecutiveSummaryRoute = {
    path: "/analytics/external/weekly-executive-summary",
    displayName: "Weekly Executive Summary",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const AttributionFunnelRoute = {
    path: "/analytics/external/attribution-funnel",
    displayName: "Attribution Funnel",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const UtmReportRoute = {
    path: "/analytics/external/utm-report",
    displayName: "UTM Report",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const ScatterplotRoute = {
    path: "/analytics/external/scatterplot",
    displayName: "Scatterplot",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    hide: true
};

const AnalyticsInternalRoute = {
    path: "/analytics/internal",
    displayName: "Internal",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    children: [
        {
            path: "/analytics/internal",
            displayName: "Landing",
            groups: [constants.THE_FILTER_FULL_AUTH]
        },
        CustomerOverviewRoute,
        BusinessImpressionsRoute,
        AdImpressionsRoute
    ]
};

const AnalyticsExternalRoute = {
    path: "/analytics/external",
    displayName: "External",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    children: [
        {
            path: "/analytics/external",
            displayName: "Landing",
            groups: [constants.THE_FILTER_FULL_AUTH]
        },
        KpiDashboardRoute,
        ContentDashboardRoute,
        GenreExplorerRoute,
        RecsDashboardRoute,
        AnalyticsPlaygroundRoute,
        DailyVideoEngagementRoute,
        DailyEventTrafficRoute,
        WeeklyExecutiveSummaryRoute,
        AttributionFunnelRoute,
        EventInfoRoute,
        UtmReportRoute,
        ScatterplotRoute
    ]
};

const AnalyticsRoute = {
    path: "/analytics",
    displayName: "Analytics",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ],
    megaMenu: true,
    children: [
        AnalyticsInternalRoute,
        AnalyticsExternalRoute,
        // Flatten leaf routes for router to pick up
        {
            path: "/analytics/internal",
            displayName: "Internal Landing",
            groups: [constants.THE_FILTER_FULL_AUTH],
            hide: true
        },
        {
            path: "/analytics/external",
            displayName: "External Landing",
            groups: [constants.THE_FILTER_FULL_AUTH],
            hide: true
        },
        KpiDashboardRoute,
        ContentDashboardRoute,
        GenreExplorerRoute,
        RecsDashboardRoute,
        CustomerOverviewRoute,
        BusinessImpressionsRoute,
        AdImpressionsRoute,
        AnalyticsPlaygroundRoute,
        DailyVideoEngagementRoute,
        DailyEventTrafficRoute,
        WeeklyExecutiveSummaryRoute,
        AttributionFunnelRoute,
        EventInfoRoute,
        UtmReportRoute,
        ScatterplotRoute
    ]
};

const BrowseViewRoute = {
    path: "/browseview",
    displayName: "Browse",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const CollectionsRoute = {
    path: "/collections",
    displayName: "Collections",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ]
};

const ModelManagerRoute = {
    path: "/modelmanager",
    displayName: "Model Manager",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH,
        constants.DEMO_FULL_AUTH
    ],
    defaultForGroup: [
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const ModelViewerRoute = {
    path: "/modelviewer",
    displayName: "Model Viewer",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const DynamicModelBuilderRoute = {
    path: "/dynamicmodelbuilder",
    displayName: "Dynamic Model Builder",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.DEMO_FULL_AUTH
    ],
    hide: true
};

const PageManagerRoute = {
    path: "/pagemanager",
    displayName: "Page Manager",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.RTVE_FULL_AUTH
    ]
};

const PageViewerRoute = {
    path: "/pageviewer",
    displayName: "Page Viewer",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const SystemHealthRoute = {
    path: "/systemhealth",
    displayName: "System Health",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const ChartsViewerRoute = {
    path: "/chartsviewer",
    displayName: "Charts",
    groups: [
        constants.THE_FILTER_FULL_AUTH,
        constants.RTVE_FULL_AUTH,
        constants.RTVE_READ_AUTH
    ]
};

const EventBridgeRoute = {
    path: "/eventbridge",
    displayName: "EventBridge",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ]
};

const SeedViewerRoute = {
    path: "/seedviewer",
    displayName: "Seed Viewer",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ]
};

const EventStreamRoute = {
    path: "/eventstream",
    displayName: "Event Stream",
    groups: [
        constants.THE_FILTER_FULL_AUTH
    ]
};

const FilterRouting: RouteConfig[] = [
    {
        path: "/entities",
        displayName: "Entities",
        groups: [constants.THE_FILTER_FULL_AUTH],
        children: [
            EntitiesRoute,
            EntitiesReportRoute,
            MultiTaggingRoute
        ]
    },
    SearchRoute,
    BrowseViewRoute,
    ChartsViewerRoute,
    {
        path: "/models",
        displayName: "Models",
        groups: [constants.THE_FILTER_FULL_AUTH],
        children: [
            ModelConfigRoute,
            ModelManagerRoute,
            DynamicModelBuilderRoute,
            ModelViewerRoute,
            PageManagerRoute,
            PageViewerRoute
        ]
    },
    {
        path: "/slots",
        displayName: "Slots",
        groups: [constants.THE_FILTER_FULL_AUTH],
        children: [
            SlotsEditorRoute,
            SlotsViewerRoute,
            TesterRoute,
            ExperimentsRoute,
            ModelComparisonRoute,
            FallbackViewerRoute
        ]
    },
    // Removed as unsupported currently
    // PagesRoute,
    {
        path: "/rules",
        displayName: "Rules",
        groups: [constants.THE_FILTER_FULL_AUTH],
        children: [
            PromotionsRoute,
            BlockingRoute
        ]
    },
    {
        path: "/builders",
        displayName: "Builders",
        groups: [constants.THE_FILTER_FULL_AUTH],
        children: [
            LaneBuilderRoute,
            PageBuilderRoute,
            CollectionsRoute
        ]
    },
    {
        path: "/monitoring",
        displayName: "Monitoring",
        groups: [constants.THE_FILTER_FULL_AUTH],
        children: [
            SystemHealthRoute,
            EventBridgeRoute,
            EventStreamRoute,
            SeedViewerRoute
        ]
    },
    AnalyticsRoute,
    
    MetadataRoute,
    EntitiesDetailRoute
];

const DemoRouting: RouteConfig[] = [
    {
        path: "/entities",
        displayName: "Entities",
        groups: [constants.DEMO_FULL_AUTH],
        children: [
            EntitiesRoute,
            MultiTaggingRoute
        ]
    },
    SearchRoute,
    BrowseViewRoute,
    {
        path: "/models",
        displayName: "Models",
        groups: [constants.DEMO_FULL_AUTH],
        children: [
            ModelManagerRoute,
            DynamicModelBuilderRoute
        ]
    },
    {
        path: "/slots",
        displayName: "Slots",
        groups: [constants.DEMO_FULL_AUTH],
        children: [
            SlotsViewerRoute,
            TesterRoute
        ]
    },
    {
        path: "/rules",
        displayName: "Rules",
        groups: [constants.DEMO_FULL_AUTH],
        children: [
            PromotionsRoute,
            BlockingRoute
        ]
    },
    MetadataRoute,
    EntitiesDetailRoute
];

const CustomerRouting: RouteConfig[] = [
    SlotsViewerRoute,
    LaneBuilderRoute,
    PromotionsRoute,
    BlockingRoute,
    SearchRoute,
    BrowseViewRoute,
    MetadataRoute
];

// const DemoCustomerRouting: RouteConfig[] = [
//     SlotsViewerRoute,
//     SearchRoute,
//     BrowseViewRoute,
//     MetadataRoute
// ];

const CustomerPageRouting: RouteConfig[] =
[
    ModelManagerRoute,
    SlotsViewerRoute,
    LaneBuilderRoute,
    PromotionsRoute,
    BlockingRoute,
    SearchRoute,
    BrowseViewRoute,
    MetadataRoute,
    PageBuilderRoute
];

const RTVERouting: RouteConfig[] =
[
    {
        path: "/models",
        displayName: "Models",
        groups: [constants.RTVE_FULL_AUTH, constants.RTVE_READ_AUTH],
        children: [
            ModelManagerRoute,
            DynamicModelBuilderRoute,
            ModelViewerRoute
        ]
    },
    {
        path: "/pages",
        displayName: "Pages",
        groups: [constants.RTVE_FULL_AUTH, constants.RTVE_READ_AUTH],
        children: [
            PageManagerRoute,
            PageViewerRoute
        ]
    },
    SlotsViewerRoute,
    ChartsViewerRoute,
    SearchRoute,
    BrowseViewRoute,
    PromotionsRoute,
    BlockingRoute,
    {
        path: "/entities",
        displayName: "Entities",
        groups: [constants.RTVE_FULL_AUTH, constants.RTVE_READ_AUTH],
        children: [
            EntitiesReportRoute,
            MultiTaggingRoute
        ]
    },
    MetadataRoute,
    SystemHealthRoute
];

const RevryAnalyticsRouting: RouteConfig[] = [
    {
        path: "/analytics",
        displayName: "Analytics",
        groups: [constants.REVRY_FULL_AUTH],
        children: [
            { ...KpiDashboardRoute, hide: false },
            { ...ContentDashboardRoute, hide: false },
            { ...GenreExplorerRoute, hide: false },
            { ...RecsDashboardRoute, hide: false },
            { ...EventInfoRoute, hide: false }
        ]
    }
];

export function getRoutingForGroup(groups: string[]): RouteConfig[] {
    if (groups?.includes(constants.THE_FILTER_FULL_AUTH)) {
        return FilterRouting;
    }

    if (groups?.includes(constants.DEMO_FULL_AUTH)) {
        return DemoRouting;
    }

    if (groups?.includes(constants.WAOO_FULL_AUTH) || groups?.includes(constants.TELENOR_FULL_AUTH)
        || groups?.includes(constants.BACKSTAGE_DEMO_FULL_AUTH)
        || groups?.includes(constants.SLOVAK_TELEKOM_FULL_AUTH)
    ) {
        return CustomerPageRouting;
    }

    if (
            groups?.includes(constants.RTVE_FULL_AUTH) ||
            groups.includes(constants.RTVE_READ_AUTH)
    ) {
        return RTVERouting;
    }

    if (groups?.includes(constants.REVRY_FULL_AUTH)) {
        return RevryAnalyticsRouting;
    }


    return CustomerRouting;
}

export function getDefaultRoute(groups: string[]): string {
    if (groups.includes(constants.THE_FILTER_FULL_AUTH) || groups.includes(constants.DEMO_FULL_AUTH)) {
        return TesterRoute.path;
    }
    else if (
        groups.includes(constants.RTVE_FULL_AUTH)||
        groups.includes(constants.RTVE_READ_AUTH)
    ) {
        return ModelManagerRoute.path;
    }
    else if (groups.includes(constants.REVRY_FULL_AUTH)) {
        return KpiDashboardRoute.path;
    }

    return SearchRoute.path;
}
